import { createContext, useContext } from 'react';
import { AuthContextValue } from './types';

export enum CognitoAuthEvent {
  SignedIn = 'signedIn',
  SignedOut = 'signedOut',
  TokenRefresh = 'tokenRefresh',
  TokenRefreshFailure = 'tokenRefresh_failure',
  SignInWithRedirect = 'signInWithRedirect',
  SignInWithRedirectFailure = 'signInWithRedirect_failure',
  CustomOAuthState = 'customOAuthState',
}

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined
);

export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
